import type { ToastMessageOptions } from "primevue/toast";

import { useErrorLog } from "@blackfisk/vue/composables/useErrorLog";
import LogRocket from "logrocket";
import ToastEventBus from "primevue/toasteventbus";

import { useSentry } from "@/composables/useSentry";
import { isLocalEnvironment } from "@/environment";
import router from "@/router";

export interface ErrorToast {
  navigation: string;
  message: string;
  messageDetail: string;
  severity: ToastMessageOptions["severity"];
  report: boolean;
  /** The original error, when one exists — reported instead of a synthesized message. */
  error?: unknown;
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useError = () => {
  const { Sentry } = useSentry();
  const { logErrorMessage } = useErrorLog();
  const errorToast = ({
    navigation = "",
    message = "",
    messageDetail = "",
    severity = "error",
    report = true,
    error,
  }: Partial<ErrorToast> = {}): void => {
    const assembledErrorMessage = `${message} | ${messageDetail}`;
    if (message) {
      logErrorMessage([assembledErrorMessage]);
      ToastEventBus.emit("add", {
        severity: severity,
        summary: message,
        detail: messageDetail,
        group: "br",
        life: 4250,
      });
    }
    if (report) {
      const reportedError = error instanceof Error ? error : new Error(assembledErrorMessage);
      Sentry.captureException(reportedError);
      if (!isLocalEnvironment) {
        LogRocket.captureException(reportedError);
      }
    }
    if (navigation) {
      router.push({
        name: navigation,
      });
    }
  };
  return {
    errorToast,
  };
};
